import IconAngle from '../../assets/icons/chevron-arrow-down.svg'
import { darkGrey, mediumGrey } from '../const/colors'
import { transitionShort } from '../const/common'

export const angleIcon = {
  content: '""',
  backgroundImage: `url("${IconAngle}")`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  width: 16,
  height: 12,
  display: 'inline-block'
}

export const backBtn = {
  position: 'absolute',
  top: 48,
  border: 0,
  padding: 0,
  backgroundColor: 'transparent',
  outline: 'none',
  fontSize: 14,
  fontWeight: 500,
  color: mediumGrey,
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  transition: transitionShort,
  '&:hover': {
    color: darkGrey
  },
  '& svg': {
    transform: 'rotate(90deg)',
    marginRight: 6
  }
}
